export default __webpack_public_path__ + "static/media/undraw_marketing_v0iu.c19b861a.svg";